import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=5449a607&scoped=true"
import script from "./PricingCard.vue?vue&type=script&lang=ts"
export * from "./PricingCard.vue?vue&type=script&lang=ts"
import style0 from "./PricingCard.vue?vue&type=style&index=0&id=5449a607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449a607",
  null
  
)

export default component.exports